var _defs, _path, _path2, _polyline, _line, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _rect3, _rect4, _path8, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path9, _rect13, _rect14, _path10, _path11, _rect15, _rect16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFortyFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_10",
    "data-name": "Camada 10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.78 120.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-7{fill:none;}.cls-1,.cls-2,.cls-5,.cls-6,.cls-7{stroke:#343233;stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-3,.cls-5{stroke-width:2.58px;}.cls-2,.cls-6{stroke-width:1.56px;}.cls-3{fill:#343333;stroke:#343333;stroke-miterlimit:10;}.cls-4,.cls-6{fill:#d83f28;}.cls-5{fill:#fff;}.cls-7{stroke-width:0.44px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.17,98.68H15.1a8,8,0,0,1-8-8V32.54h93.6",
    transform: "translate(-5.77 -5.14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14,52.47v-7a6.18,6.18,0,0,1,6.18-6.18H33.71",
    transform: "translate(-5.77 -5.14)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "21.89 60.47 8.24 60.47 8.24 47.33 21.31 47.33"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.27,
    y1: 73.61,
    x2: 8.27,
    y2: 60.47
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.67,91.89H20.2A6.18,6.18,0,0,1,14,85.71v-7H27.67",
    transform: "translate(-5.77 -5.14)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.41,9.39H86.77a8.12,8.12,0,0,1,8.12,8.12V27.4a0,0,0,0,1,0,0H1.29a0,0,0,0,1,0,0V17.51A8.12,8.12,0,0,1,9.41,9.39Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 17.53,
    width: 7.74,
    height: 16.17,
    rx: 3.87
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 70.84,
    width: 7.74,
    height: 16.17,
    rx: 3.87
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.89,52.59h93.6a0,0,0,0,1,0,0V110.7a8,8,0,0,1-8,8H29.93a8,8,0,0,1-8-8V52.59a0,0,0,0,1,0,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35.05,59.38H48.54a0,0,0,0,1,0,0V72.52a0,0,0,0,1,0,0H28.88a0,0,0,0,1,0,0v-7A6.18,6.18,0,0,1,35.05,59.38Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M35,59.38H48.54a0,0,0,0,1,0,0V72.52a0,0,0,0,1,0,0H28.85a0,0,0,0,1,0,0v-7A6.18,6.18,0,0,1,35,59.38Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.54,
    y: 59.38,
    width: 19.69,
    height: 13.14
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.24,
    y: 59.38,
    width: 19.69,
    height: 13.14
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.93,59.38h13.51a6.18,6.18,0,0,1,6.18,6.18v7a0,0,0,0,1,0,0H87.93a0,0,0,0,1,0,0V59.38A0,0,0,0,1,87.93,59.38Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.85,
    y: 72.52,
    width: 19.69,
    height: 13.14
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.54,
    y: 72.52,
    width: 19.69,
    height: 13.14
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.24,
    y: 72.52,
    width: 19.69,
    height: 13.14
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 87.93,
    y: 72.52,
    width: 19.69,
    height: 13.14
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 87.93,
    y: 85.66,
    width: 19.69,
    height: 13.14
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.88,
    y: 85.66,
    width: 19.67,
    height: 13.14
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.54,
    y: 85.66,
    width: 19.69,
    height: 13.14
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.24,
    y: 85.66,
    width: 19.69,
    height: 13.14
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.85,98.81H48.54a0,0,0,0,1,0,0v13.14a0,0,0,0,1,0,0H35a6.18,6.18,0,0,1-6.18-6.18v-7A0,0,0,0,1,28.85,98.81Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.54,
    y: 98.81,
    width: 19.69,
    height: 13.14
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.24,
    y: 98.81,
    width: 19.69,
    height: 13.14
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.93,98.81h19.69a0,0,0,0,1,0,0v7a6.18,6.18,0,0,1-6.18,6.18H87.93a0,0,0,0,1,0,0V98.81A0,0,0,0,1,87.93,98.81Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30,34.59h77.36a8.12,8.12,0,0,1,8.12,8.12v9.88a0,0,0,0,1,0,0H21.89a0,0,0,0,1,0,0V42.71A8.12,8.12,0,0,1,30,34.59Z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 38.13,
    y: 25.2,
    width: 7.74,
    height: 16.17,
    rx: 3.87
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 91.44,
    y: 25.2,
    width: 7.74,
    height: 16.17,
    rx: 3.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortyFive);
export default __webpack_public_path__ + "static/media/forty-five.cfff960514ef1c596a3de3b6667d43e0.svg";
export { ForwardRef as ReactComponent };